import { LizanoReportResponse as AccountNotesInterface } from '@/reports/sections/ListsSection/lists/lists';
import { useReportRedirect } from '@/reports/useReportRedirect/useReportRedirect';
import { Button } from '@/theme/index';
import { ValidReportTypes } from '@/utils/helperTypes';
import { AccountNotesList } from './AccountNotesList';
import { AccountNotesCard } from './components';
import { useAccountNotes } from './useAccountNotes';

export function AccountNotes() {
  const { redirectToReportUrl } = useReportRedirect();
  const { data, isLoading, isError } = useAccountNotes();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error, fetching notes!</div>;
  }

  return (
    <div>
      {data?.map((report: AccountNotesInterface) => (
        <AccountNotesCard
          key={`account-note-${report.permalink}`}
          report={report}
        >
          <AccountNotesList report={report} />
          <Button
            variant="contained"
            color="success"
            onClick={() =>
              redirectToReportUrl(
                report.report_type as ValidReportTypes,
                report.permalink
              )
            }
            sx={{
              display: { xs: 'block', md: 'none' },
              margin: '0 auto',
            }}
          >
            View Report
          </Button>
        </AccountNotesCard>
      ))}
    </div>
  );
}
